import React from 'react';
import { Plane } from '@react-three/drei';
import * as THREE from 'three';

const StoreFloor = ({ size = 20, color = '#f0f0f0', gridColor = '#cccccc' }) => {
  return (
    <group>
      {/* Main Floor */}
      <Plane
        args={[size, size]}
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, 0, 0]}
        receiveShadow
      >
        <meshStandardMaterial color={color} />
      </Plane>
      
      {/* Floor Border */}
      <lineSegments>
        <edgesGeometry args={[new THREE.PlaneGeometry(size, size)]} />
        <lineBasicMaterial color={gridColor} />
      </lineSegments>
    </group>
  );
};

export default StoreFloor;
